<template>
  <div class="menu">
    <div class="menu__panel">
      <div class="panel">
        <div class="panel__header">
          <p>学習する</p>
        </div>
        <div class="panel__body">
          <VuePerfectScrollbar class="scroll-area" v-bind:settings="settings" tagname="div" ref="ps">
            <div class="panel__content" ref="panelContent">
              <ul class="items">
                <li class="item car">
                  <div class="item__inner" v-on:click="gotoMenuStudy1" ref="gotoMenu">
                    <p>車の基礎知識</p>
                  </div>
                </li>
                <li class="item repaire">
                  <div class="item__inner">
                    <p>修理の基礎知識</p>
                  </div>
                </li>
                <li class="item tool">
                  <div class="item__inner">
                    <p>工具の基礎知識</p>
                  </div>
                </li>
                <li class="item customer">
                  <div class="item__inner">
                    <p>接客の基礎知識</p>
                  </div>
                </li>
                <li class="item trouble">
                  <div class="item__inner">
                    <p>トラブル対応について</p>
                  </div>
                </li>
                <li class="item exam">
                  <div class="item__inner" v-on:click="gotoMenuExam1" >
                    <p>学科試験過去問題</p>
                  </div>
                </li>
                <li class="item compliance">
                  <div class="item__inner">
                    <p>コンプライアンス</p>
                  </div>
                </li>
                <li class="item delivery">
                  <div class="item__inner">
                    <p>配送</p>
                  </div>
                </li>
              </ul>
            </div>
          </VuePerfectScrollbar>
        </div>
      </div>
    </div>
    <div class="menu__return">
      <div v-on:click="onReturn()" class="modal-box__return">
        <img :src="`${staticPath}img/factory/btn_return.png`">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/study_menu.scss';

  .item__inner {

    >p {
      padding-left: 30px;
    }

    &::before {
      content: '';
      display: block;
      position: absolute;
      width: 25px;
      height: 25px;
      left: 15px;
      top: calc(50% - 12px);
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  .item.car .item__inner::before {
    background-image: url('/static/img/factory/study/icon_car.png');
  }

  .item.repaire .item__inner::before {
    background-image: url('/static/img/factory/study/icon_repaire.png');
  }

  .item.tool .item__inner::before {
    background-image: url('/static/img/factory/study/icon_tool.png');
  }

  .item.customer .item__inner::before {
    background-image: url('/static/img/factory/study/icon_customer.png');
  }

  .item.trouble .item__inner::before {
    background-image: url('/static/img/factory/study/icon_trouble.png');
  }

  .item.exam .item__inner::before {
    background-image: url('/static/img/factory/study/icon_exam.png');
  }

  .item.compliance .item__inner::before {
    background-image: url('/static/img/factory/study/icon_compliance.png');
  }

  .item.delivery .item__inner::before {
    background-image: url('/static/img/factory/study/icon_delivery.png');
  }

  .scroll-area {
    height: 100%;
    padding-right: 15px;
  }
</style>

<style lang="scss">
  @import '@/assets/scss/_scrollbar.scss';
</style>

<script>
  import Constant from '@/constant';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';

  export default {
    name: 'MenuMain',

    components: {
      VuePerfectScrollbar
    },

    data(){
      return {
        staticPath: Constant.STATICPATH,

        settings: {
          suppressScrollX: true,
          swipeEasing: false
          //maxScrollbarLength: 300
        },
        
        touch_start: false
      }
    },

    mounted() {

      var ps = this.$refs.ps;
      ps.update();

      var methodStudy1 = this.gotoMenuStudy1;      
      var gotoStudy = this.$refs.gotoMenu;
      gotoStudy.addEventListener('touchstart', methodStudy1);

      // var gotoStudy = this.$refs.gotoMenu;
      // gotoStudy.addEventListener('touchstart', () => {
      //   this.touch_start = true;
      // });

      // gotoStudy.addEventListener('touchend', () => {
        
      //   if (this.touch_start) {
      //     this.gotoMenuStudy1();
      //     this.touch_start = false;
      //   }
      // });
    },

    methods: {

      gotoMenuStudy1() {
        this.$emit('goto-menu-study1');
      },

      gotoMenuExam1() {
        this.$emit('goto-menu-exam1');
      },

      onReturn() {
        this.$emit('on-return');
      },
    },

    beforeDestroy() {
      var methodStudy1 = this.gotoMenuStudy1;
      var gotoStudy = this.$refs.gotoMenu;
      gotoStudy.removeEventListener('touchstart', methodStudy1);
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Study/MenuMain.vue